// Bibliotecas
import React from 'react';
import cn from 'classnames';

// Componentes
import Product from './../Product/Product';
import Options from './Options/Options';
import VerticalExpander from './../global/VerticalExpander/VerticalExpander';

import './Detail.css'; // CSS

class Detail extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            activeButton: false,
            product: JSON.parse(JSON.stringify(props.product)),
            verticalExpand: false
        };

        this.isProductNoOptions = this.state.product.id === 9;
        this.showPackingDescription = this.state.product.id === 10;
    }

    addToCart = () => {
        if(!this.state.activeButton) return;

        const {onAddToCart, onClose} = this.props;
        
        onAddToCart(this.state.product);
        onClose();
    }

    activeButton = () => {
        if(!this.state.activeButton)
            this.setState({activeButton: true});
    }

    markOption = (id, optionName) => {
        const product = this.state.product;
        const options = product.options;
        
        options[optionName].values = options[optionName].values.map(option => {
            option.mark = option.id == id? true : false;
            return option;
        });
        
        this.setState({product});
    }

    componentDidMount(){
        if(this.isProductNoOptions)
            this.activeButton();
        
        setTimeout(() => {
            this.setState({verticalExpand: true});
        }, 400);
    }
    
    render(){
        const {productTop, onClose} = this.props;
        const {activeButton, product, verticalExpand} = this.state;
        const detailProductStyle = {bottom: productTop || 0};

        return (
            <div className="detail" onClick={onClose}>
                <div className="detail__inner">
                    <div className="detail__product" style={detailProductStyle} onClick={(e) => e.stopPropagation()}>
                        <Product
                            id={1000}
                            name={product.name}
                            weights={product.options.weights.values}>
                            
                            <VerticalExpander expand={verticalExpand}>

                                {!this.isProductNoOptions ? (
                                    <Options
                                        options={product.options}
                                        showPackingDescription={this.showPackingDescription}
                                        onMarkOption={this.markOption}
                                        onComplete={this.activeButton} />
                                ) : (
                                    <div
                                        style={{
                                            padding: '0px 0 15px 58px',
                                            color: '#75300e'
                                        }}>
                                        {product.description}
                                    </div>
                                )}
                                
                            </VerticalExpander>
                        </Product>

                        <VerticalExpander expand={verticalExpand}>
                            <div className="detail__bar" onClick={(e) => e.stopPropagation()}>
                                <span className="orange-button-light" onClick={onClose}>
                                    Cancelar
                                </span>
                                
                                <span
                                    className={cn("detail__add-to-cart orange-button", {"detail__add-to-cart--enable": activeButton})}
                                    onClick={this.addToCart}>
                                    Adicionar a sacola
                                </span>
                            </div>
                        </VerticalExpander>
                    </div>
                </div>
            </div>
        );
    }
}

export default Detail;